import BtnGoodsCounter from './BtnGoodsCounter'

export default BtnGoodsCounter
